export type AbacBulkFeatureUpdate = {
  feature_id: string;
  attribute_ids: string[];
};

export type AbacBulkUpdatePayload = {
  features: AbacBulkFeatureUpdate[];
};

export function buildAbacBulkUpdatePayload(
  featureIds: string[],
  selections: Record<string, Set<string>>,
): AbacBulkUpdatePayload {
  return {
    features: featureIds.map((featureId) => ({
      feature_id: featureId,
      attribute_ids: Array.from(selections[featureId] || []),
    })),
  };
}
